/**
 * Defer BATON WebSocket connect until the shell is usable — boot must not wait on realtime.
 */

export const BATON_LAZY_CONNECT_DELAY_MS = 1200;

let scheduledTimer: ReturnType<typeof setTimeout> | null = null;

export function scheduleLazyBatonConnect(kick: () => void, _source = 'lazy'): void {
  if (scheduledTimer) clearTimeout(scheduledTimer);
  scheduledTimer = setTimeout(() => {
    scheduledTimer = null;
    kick();
  }, BATON_LAZY_CONNECT_DELAY_MS);
}

export function cancelLazyBatonConnect(): void {
  if (scheduledTimer) clearTimeout(scheduledTimer);
  scheduledTimer = null;
}

export function resetBatonLazyConnectForTests(): void {
  cancelLazyBatonConnect();
}
